<template src="./template.html"></template>
<script>
import moment from 'moment'
import _isNumber from 'lodash/isNumber'
import { mapState } from 'vuex'
import Vue from 'vue'

import iframeWidgetBaseMixin from 'mixins/iframeWidgetBase'
import InventoryListWithDatePicker from 'components/InventoryListWithDatePicker'
import iframeLib from 'lib/iframe'
import IFRAME_MESSAGE_TYPES from 'shared/constants/iframeMessageTypes'
import config from 'src/config'
import dateUtils from 'utils/dateUtils'
import store from 'src/store'
import * as mutationTypes from 'store/mutationTypes'

export default {
  name: 'inventory-list-widget',
  components: {
    InventoryListWithDatePicker,
  },
  mixins: [iframeWidgetBaseMixin],
  computed: {
    ...mapState({
      date: (state) => state.date.current,
      venue: (state) => state.venue.current,
      items: (state) => state.checkout.items,
    }),
  },
  data() {
    let theme = this.$route.query.theme

    //NOTE: couple of widget instances were using this old style
    if (theme === 'widget-theme-dark') {
      theme = 'theme-light'
    }

    //TODO: should eventually get the venue to update their code
    //
    if (this.$route.query.client !== 'web') {
      //ignore on the Tablelist website
      if (this.$route.query.venueId === '10c9eab35197e411') {
        //NOTE: hardcode Shore Club to fix their widget colors
        theme = 'theme-light'
      }
      if (this.$route.query.venueId === 'de32adad9465bdeb') {
        //NOTE: hardcode Living Room DC to fix their widget colors
        theme = 'theme-dark'
      }
      if (this.$route.query.venueId === 'c853ae83c8cd78b6') {
        //NOTE: hardcode Exixir Lounge to fix their widget colors
        theme = 'theme-dark'
      }
      if (this.$route.query.venueId === '335c7e30719ae03e') {
        //NOTE: hardcode Storyville to fix their widget colors
        theme = 'theme-dark'
      }
      if (this.$route.query.venueId === '9106e9cf5d351d4c') {
        //NOTE: hardcode Tunnel to fix their widget colors
        theme = 'theme-dark'
      }
      if (this.$route.query.venueId === 'eb68f0f673d5349c') {
        //NOTE: hardcode Paddy's to fix their widget colors
        theme = 'theme-dark'
      }
    }

    let shouldLockDate = false

    if (this.$route.query.date && this.$route.query.date.length) {
      let date

      if (moment(this.$route.query.date, moment.ISO_8601, true).isValid()) {
        date = moment.utc(this.$route.query.date, moment.ISO_8601)
      } else {
        const dateNum = parseInt(this.$route.query.date, 10)

        if (_isNumber(dateNum)) {
          date = moment.utc(parseInt(this.$route.query.date, 10), 'x')
        } else {
          date = moment.utc(this.$route.query.date)
        }
      }

      if (date.isValid()) {
        date = dateUtils.toUTCMomentWithoutTime(date)

        this.$store.dispatch('setCurrentDate', date)

        shouldLockDate = true
      }
    }

    if (this.$route.query.venueId === 'f07dd28fd5ccca39' || this.$route.query.venueId === 'b09b9055e3191712') {
      //NOTE: hardcode illinois s&p collinsville and springfield rec to not lock dates
      shouldLockDate = false
    }

    return {
      loading: true,
      venueId: this.$route.query.venueId,
      eventId: this.$route.query.eventId,
      inventoryId: this.$route.query.inventoryId,
      inventoryType: this.$route.query.inventoryType,
      shouldLockDate,
      affiliateId: this.$route.query.affiliateId,
      trackingId: this.$route.query.trackingId,
      attributionId: this.$route.query.attributionId,
      bgColor: this.$route.query.bgColor,
      buttonBgColor: this.$route.query.buttonBgColor,
      buttonTextColor: this.$route.query.buttonTextColor,
      buttonText: this.$route.query.buttonText,
      disableInlineCheckout: this.$route.query.disableInlineCheckout === 'true',
      client: this.$route.query.client,
      checkoutUrl: this.$route.query.checkoutUrl,
      theme,
    }
  },
  methods: {
    onScrollTop() {
      iframeLib.publish(
        {
          name: config.IFRAME_MESSAGE_NAME,
          type: IFRAME_MESSAGE_TYPES.WIDGET_SCROLL_TOP,
          iframeId: this.iframeId,
        },
        {
          parent: true,
        }
      )
    },
    onIframeBlurred() {
      this.$refs.inventoryListWithDatePicker.closeDatePicker()
    },
    onDatepickerOpened() {
      Vue.nextTick(() => {
        this.publishDimensions({
          minHeight: 420,
        })
      })
    },
    onInventorySelected(data) {
      iframeLib.publish(
        {
          name: config.IFRAME_MESSAGE_NAME,
          type: IFRAME_MESSAGE_TYPES.INVENTORY_SELECTED,
          iframeId: this.iframeId,
          data: Object.assign(data, {
            affiliateId: this.affiliateId,
            attributionId: this.attributionId,
            trackingId: this.trackingId,
            client: this.client,
          }),
        },
        {
          parent: true,
        }
      )
    },
    onUpdated() {
      this.publishDimensions()
    },
    onMutation(mutation) {
      if (mutation.type === mutationTypes.START_CHECKOUT) {
        iframeLib.publish(
          {
            name: config.IFRAME_MESSAGE_NAME,
            type: IFRAME_MESSAGE_TYPES.CHECKOUT,
            iframeId: this.iframeId,
            data: {
              items: this.items,
              affiliateId: this.affiliateId,
              attributionId: this.attributionId,
              trackingId: this.trackingId,
              client: this.client,
            },
          },
          {
            parent: true,
          }
        )

        this.$store.dispatch('clearCheckoutCartItems')
      }
    },
  },
  created() {
    this.storeUnsubscribe = store.subscribe(this.onMutation)

    this.loading = true

    const promises = [this.$store.dispatch('getVenue', this.$route.query.venueId), this.$store.dispatch('getCurrentLayoutSections', this.$route.query.venueId)]

    if (this.eventId) {
      promises.push(this.$store.dispatch('setConfigEventId', this.eventId))
    }

    if (this.attributionId) {
      promises.push(this.$store.dispatch('setConfigAttributionId', this.attributionId))
    }

    if (this.affiliateId) {
      promises.push(this.$store.dispatch('setConfigAffiliateId', this.affiliateId))
    }

    if (this.trackingId) {
      promises.push(this.$store.dispatch('setConfigTrackingId', this.trackingId))
    }

    if (this.client) {
      promises.push(this.$store.dispatch('setConfigClient', this.client))
    }

    Promise.all(promises)
      .then(() => {
        this.loading = false
      })
      .catch(() => {
        this.loading = false
      })
  },
  destroyed() {
    if (this.storeUnsubscribe) this.storeUnsubscribe()
  },
}
</script>



// WEBPACK FOOTER //
// src/pages/Widgets/InventoryList/index.vue